//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
import "../AME/AME.SelectAMEBaseNodeList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Description",1,0],[0,"InsertMethodAuto",1,0],[0,"MethodName",1,0],[1,"SelectedObjects",0,"AME.SelectAMEBaseNodeList",0],[0,"ShowInAutomation",1,0],[0,"ShowInFunction",1,0],[0,"ShowInLocation",1,0],[0,"ShowInProduct",1,0]],[[["plcBlock"],"SetPlcCodeBlock",{},1,0],[["compileUnitStartIndex","compileUnitEndIndex"],"AddCompileUnitIndex",{},2,0],[["compileUnitIndex","startStatementIndex","endStatementIndex"],"AddStatementIndexes",{},3,0],[["startUId","endUId"],"AddStatementUnitUIdRange",{},2,0]],[]];
SPLM.AME.CreateMethodBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.CreateMethodBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;